import { initializeApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";

const app = initializeApp({
  apiKey: "AIzaSyDQLRaGFA_WnMewQ1XtlGV7NBMTKtH-kYs",
  authDomain: "katenaria-dc7d7.firebaseapp.com",
  projectId: "katenaria-dc7d7",
  storageBucket: "katenaria-dc7d7.firebasestorage.app",
  messagingSenderId: "1047313191353",
  appId: "1:1047313191353:web:0a725a66a4a32e99e9e668",
});

const functions = getFunctions(app, "us-central1");
const sendContactEmailFn = httpsCallable(functions, "sendContactEmail");

export async function sendContactEmail(data: {
  name: string;
  email: string;
  message: string;
}): Promise<{ success: boolean; error?: string }> {
  try {
    await sendContactEmailFn({ ...data, message: `Source: coprocessor-landing\n\n${data.message}` });
    return { success: true };
  } catch (err: any) {
    return { success: false, error: err.message || "Failed to send message. Please try again." };
  }
}
